import {
    OutwardReferralData,
    OutwardReferralResponse,
    OutwardReferralListQuery,
    OutwardReferralUpdatingParams,
    OutwardReferralCreationParams,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/outward-referral';

export interface OutwardReferralIdentity {
    outwardReferralId: string;
}

export class OutwardReferralApi {
    public static async find(params: OutwardReferralListQuery): Promise<OutwardReferralData[]> {
        const res = await axios.get<OutwardReferralResponse>(`${BASE_URL}`, { params });

        return res.data.outwardReferrals;
    }

    public static async findWithCount(params: OutwardReferralListQuery): Promise<OutwardReferralResponse> {
        const res = await axios.get<OutwardReferralResponse>(`${BASE_URL}`, { params });

        return res.data;
    }

    public static async create(outwardReferral: OutwardReferralCreationParams): Promise<void> {
        await axios.post(`${BASE_URL}`, { outwardReferral });
    }

    public static async update(
        outwardReferralId: string,
        outwardReferral: OutwardReferralUpdatingParams,
    ): Promise<void> {
        await axios.put(`${BASE_URL}/${outwardReferralId}`, { outwardReferral });
    }

    public static async changIsExecuted(
        outwardReferralId: string,
        isExecuted: boolean,
        executionEntryId?: string,
    ): Promise<void> {
        await axios.put(`${BASE_URL}/${outwardReferralId}/status`, {
            outwardReferral: { isExecuted, executionEntryId },
        });
    }

    public static async remove(outwardReferralId: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${outwardReferralId}`);
    }
}
